import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import OpenSeadragonViewer from '../../widgets/OpenSeadragon';
import styles from './SlidePreviewModal.module.css';

/**
 * Lightweight slide preview modal — plain OSD viewer, no annotations.
 *
 * Extension point: to add annotation support in the future, replace
 * OpenSeadragonViewer with OpenSeadragonAnnotate and pass onViewerReady
 * to layer on the annotation toolkit. The modal interface (itemId, itemName,
 * onClose) would not need to change.
 */
export default function SlidePreviewModal({ itemId, itemName, onClose }) {
    useEffect(() => {
        const handler = (e) => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('keydown', handler);
        return () => document.removeEventListener('keydown', handler);
    }, [onClose]);

    return createPortal(
        <div className={styles.backdrop} onClick={onClose}>
            <div className={styles.panel} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <span className={styles.title} title={itemName}>{itemName}</span>
                    <button className={styles.closeBtn} onClick={onClose} aria-label="Close preview">×</button>
                </div>
                <div className={styles.viewerWrap}>
                    <OpenSeadragonViewer
                        itemId={itemId}
                        style={{ width: '100%', height: '100%' }}
                    />
                </div>
            </div>
        </div>,
        document.body
    );
}
